import {
	SHOPALBUM_LOADING,
	SHOPALBUM_SAVING_FAILED,
	SHOPALBUM_SAVING_SUCCESSED,
} from "../actions/types";
const initialState = {
	data: {},
	saved: false,
};
export default function (state = initialState, action) {
	switch (action.type) {
		case SHOPALBUM_LOADING:
			return {
				...state,

				saved: false,
			};
		case SHOPALBUM_SAVING_SUCCESSED:
			return {
				...state,
				data: action.payload,
				saved: true,
			};
		case SHOPALBUM_SAVING_FAILED:
			return {
				...state,
				saved: false,
			};
		default:
			return state;
	}
}
